import { Translations } from '@/types/types';
import { QueryKey } from '@/configs/queryKeys';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AttributeViewType {
	TILES = 'TILES',
	CHIP = 'CHIP',
}

export enum AttributeType {
	MODULE = 'MODULE',
	GLOBAL = 'GLOBAL',
}

export interface Attribute extends BaseEntity {
	name: string;
	description: string;
	shopButtonLabel: string;
	viewType: AttributeViewType;
	listOrder: number;
	type: AttributeType;
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class AttributeApi extends EntityApi<Attribute> {
	constructor() {
		super(QueryKey.attributes);
	}
}

export default new AttributeApi();
